import { Col, Row, Segmented, Spin } from "antd";
import { useTranslation } from "react-i18next";

import { useEffect, useState } from "react";
import {
  useGetSupportedPhoneBrands,
  useGetSupportedPhoneModelList,
} from "../../hooks/SupportedDevice/supporteddevice.hooks";
import CustomModal from "../CustomModal";

import styles from "./style.module.scss";
import "./style.scss";

const SupportedDeviceModal = ({
  open,
  setOpen,
}: {
  open: boolean;
  setOpen: (val: boolean) => void;
}) => {
  const { t } = useTranslation();
  const [segmentedItems, setSegmentedItems] = useState<string[]>([]);
  const [selectedBrand, setSelectedBrand] = useState<any>("");
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const hintEnum = [
    { key: "supportedDevice.modal.hint1", visible: false },
    { key: "supportedDevice.modal.hint2", visible: true },
    { key: "supportedDevice.modal.hint3", visible: true },
    {
      key: "supportedDevice.modal.hint4",
      visible: true,
    },
  ];
  const { data } = useGetSupportedPhoneBrands({});
  const { data: modelList, isPending: isLoadingModelList } =
    useGetSupportedPhoneModelList(
      { brand: selectedBrand },
      { enabled: !!selectedBrand }
    );

  const renderHint = () => {
    return (
      <>
        {hintEnum.map((item, index) => {
          if (!item.visible) return <></>;
          return (
            <li
              key={index}
              className={styles.hint}
              dangerouslySetInnerHTML={{
                __html: t(item.key),
              }}
            />
          );
        })}
      </>
    );
  };

  useEffect(() => {
    if (data) {
      const items: string[] = [];
      data?.map((item: { brand: string; id: number }) =>
        items.push(item.brand)
      );
      if (items.length > 0) {
        setSelectedBrand(items[0]);
      } else {
        setSelectedBrand("");
      }
      setSegmentedItems(items);
    }
  }, [data]);

  useEffect(() => {
    const handleWindowResize = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleWindowResize);
    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  });
  return (
    <CustomModal
      open={open}
      onOk={() => setOpen(false)}
      onCancel={() => setOpen(false)}
      centered={true}
    >
      <div className={styles.supportedDevice}>
        <div className={styles.description}>
          <div className={styles.title}>{t("normal.esim.support.device")}</div>
          <div className={styles.warning}>
            {t("supportedDevice.modal.warning")}
          </div>
          <ul className={styles.pcHint}>{renderHint()}</ul>
        </div>
        <div className={styles.deviceList}>
          <Segmented
            block
            options={segmentedItems}
            value={selectedBrand}
            onChange={(val) => setSelectedBrand(val)}
            className="supported-device-segmented"
          />
          <div className={styles.modelListContainer}>
            <Spin spinning={isLoadingModelList || !modelList}>
              <Row gutter={[4, 4]}>
                {modelList?.map(
                  (item: { id: number; brand: string; model: string }) => (
                    <Col
                      className="gutter-row"
                      span={windowWidth >= 768 ? 8 : 12}
                      key={item.model}
                    >
                      <div className={styles.modelText}>
                        {item.id === 5
                          ? t("supportedDevice.11andUp")
                          : item.model}
                      </div>
                    </Col>
                  )
                )}
              </Row>
            </Spin>
            {selectedBrand?.toLowerCase() === "apple" ? (
              <div className={styles.appleHint}>
                {t("supportedDevice.modal.ios.hint")}
                {/* <div>{t("supportedDevice.modal.ios.hint.two")}</div> */}
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
        <ul className={styles.mobileHint}>{renderHint()}</ul>
      </div>
    </CustomModal>
  );
};

export default SupportedDeviceModal;
